import Vue from "vue";
import VueRouter from "vue-router";
import {
  findRouteNameByPath
} from "@/libs/util";
import Layout from "../views/main/main.vue";
import store from '@/store'
import {
  getToken,
  setToken
} from '@/libs/util'
import config from '@/config'
const {
  mobApps,
  mobAppActiveGroup
} = config

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "_home",
    redirect: '/home',
    component: Layout,
    meta: {
      login: true,
      hideInMenu: true,
      access: [],
    },
    children: [{
        path: 'home',
        name: 'home',
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
        },
        component: () => import("../views/home"),
      },
      {
        path: 'settings/:mode',
        name: 'settings',
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
        },
        component: () => import("../views/modules/sys/settings"),
      },
      {
        path: 'notification',
        name: 'notification',
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
        },
        component: () => import("../views/modules/sys/notification"),
      },
      {
        path: 'media/home',
        name: 'mediaHome',
        meta: {
          login: true,
          hideInMenu: false,
          access: [],
          title: 'Динамик драйв',
          notCache: true,
          icon: 'mdi-file-document-outline',
        },
        component: () => import("../views/modules/media"),
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
    component: () => import("../views/login")
  },
  {
    path: "/404",
    name: "notfound",
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
    component: () => import("../views/modules/sys/notfound")
  },
  {
    path: "/vet-med",
    name: "vet-med",
    component: () => import("../views/apps/vet-med/landing/home.vue"),
    meta: {
      header: false,
      login: false,
    }
  },
  {
    path: "/vet-landing-help/:cid/:id",
    name: "vetLandingHelp",
    component: () => import("../views/apps/vet-med/landing/help.vue"),
    meta: {
      header: false,
      login: false,
    },
  },
  {
    path: "/vet-landing-meds",
    name: "vetLandingMeds",
    component: () => import("../views/apps/vet-med/landing/meds.vue"),
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
  },
  {
    path: "/vet-landing-lics",
    name: "vetLandingLics",
    component: () => import("../views/apps/vet-med/landing/lics.vue"),
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
  },
  
  /*===================== VET DRUG  ==========================*/
  {
    path: "/ia-vm-req",
    name: "_ia-vm-req",
    component: Layout,
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
    children: [
      {
        path: 'list/:ot',
        name: 'vetMedList',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 463,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'activemedcert/:ot',
        name: 'vetMedMy',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 478,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'law-db/:ot',
        name: 'vetMedLaw',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 487,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'law-juram/:ot',
        name: 'vetMedJuram',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 488,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/cert/:ot',
        name: 'vetMedListCert',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 464,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/lic/:ot',
        name: 'vetMedLics',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 467,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/req/:ot',
        name: 'vetMedListReq',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 465,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'medicine/:ot',
        name: 'vetMedMedicine',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 472,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'medicine-accepted-meds/:ot',
        name: 'vetMedAcceptedMeds',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 477,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'video-conference/:ot',
        name: 'vidConference',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 493,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'sys-reports/:ot',
        name: 'sysReports',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 451,
        },
        component: () => import("../views/modules/report"),
      },
      {
        path: 'medicine-accepted-org-license/:ot',
        name: 'vetMedAcceptedOrgLicences',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 476,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'medicine-accepted-samples/:ot',
        name: 'vetMedAcceptedSamples',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 481,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/special/:ot',
        name: 'vetMedSpecial',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 468,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/sample/:ot',
        name: 'vetMedSample',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 479,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/users/:ot',
        name: 'vetMedUsers',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 138,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
    ]
  },
];

const router = new VueRouter({
  mode: 'hash',
  //mode: 'history',
  routes
});

// function appDirect(appHost, to, next) {
//   var childRoutes = routes.filter(x => x.name == appHost.routeParent)[0].children;
//   if (childRoutes.filter(x => x.name == to.name).length > 0) {
//     store.dispatch('getUserInfo').then(user => {
//       document.title = appHost.title;
//       $("#gofavicon").attr("href",appHost.fav);

//       if (childRoutes.filter(x => x.name == to.name)[0].login == true) {
//         if (store.state.user.userId != "") {
//           next()
//         } else {
//           next({
//             name: appHost.loginName
//           })
//         }
//       } else {
//         next()
//       }
//     }).catch(() => {
//       next({
//         name: appHost.homeName
//       })
//     })
//   } else {
//     next({
//       name: appHost.homeName
//     })
//   }
// }


router.beforeEach((to, from, next) => {
  store.dispatch('handleLoading', {
    isLoading: true
  });

  const token = getToken()
  let host = mobApps.filter(x => x.id == mobAppActiveGroup)[0];

  if (!token) {
    console
    if (host.hasHomePage) {
      store.dispatch('handleJWT', {
        key: host.key
      }).then(JWT => {
        if (JWT != false) {
          next({
            name: host.defaultHome
          })
        } else {
          next({
            name: 'login'
          })
        }

      });
    } else {
      if ('login' == to.name) {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  } else {
    if (to.matched.length == 0) {
      console.log('handleRoutes hiih gj bna');
      store.dispatch('handleRoutes', {
        router
      }).then(res => {
        let toPath = findRouteNameByPath(res, to.path);
        if (toPath != '') {
          if (toPath.meta.login) {
            if (store.state.user.userId != "") {
              next({
                name: toPath.name,
                params: {
                  ot: toPath.meta.ot
                }
              })
            }
            else{
              store.dispatch('handleUserInfo', {
                store: store
              }).then(user => {
                if (user != false) {
                  if (user.data.user_id == "") {
                    setToken('')
                    next({
                      name: 'login',
                    })
                  } else {
                    store.dispatch('handleGroupDefaultProjects', {
                      store: store
                    }).then(projects => {
                      if (projects != false)
                        {
                          next({
                            name: toPath.name,
                            params: {
                              ot: toPath.meta.ot
                            }
                          })
                        }
                      else {
                        setToken('')
                        next({
                          name: 'login',
                        })
                      }
                    })
                  }
      
                } else {
                  setToken('')
                  next({
                    name: 'login',
                  })
                }
      
              }).catch(() => {
                setToken('')
                next({
                  name: 'login',
                  //params: {"redirect":"1"}
                })
              });
            }
            
          } else {
            next({
              name: toPath.name,
              params: {
                ot: toPath.meta.ot
              }
            })
          }
        } else {
          next({
            name: 'login',
          })
        }
      });
    } else if (to.meta.login) {      
      if (store.state.user.userId != "") {
        next();
      } else {
        store.dispatch('handleUserInfo', {
          store: store
        }).then(user => {
          if (user != false) {
            if (user.data.user_id == "") {
              setToken('')
              next({
                name: 'login',
              })
            } else {
              store.dispatch('handleGroupDefaultProjects', {
                store: store
              }).then(projects => {
                if (projects != false)
                {
                  store.dispatch('handleRoutes', {router: router}).then(()=>{
                    next();
                  }).catch(()=>{
                    setToken('')
                    next({
                      name: 'login',
                    })
                  });

                  
                }
                else {
                  setToken('')
                  next({
                    name: 'login',
                  })
                }
              })
            }

          } else {
            setToken('')
            next({
              name: 'login',
            })
          }

        }).catch(() => {
          setToken('')
          next({
            name: 'login',
          })
        });
      }
    } else {
      if (host.hasHomePage && store.state.user.userId == "") {        
        if (host.defaultHome == to.name 
          || (to.name == 'login' && from.name != null) 
          || (to.name == 'login') 
          || (to.name == 'vetLandingMeds') || (to.name == 'vetLandingLics') || (to.name == 'vetLandingHelp')
        ) {
          next()
        } else {
          next({
            name: host.defaultHome
          });
        }
      } else {
        next();
      }
    }
  }


})

router.afterEach(() => {
  store.dispatch('handleLoading', {
    isLoading: false
  });
  window.scrollTo(0, 0)
})

export default router;